/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItem_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespComplementaryItemsGrid_viewer$ref: FragmentReference;
export type PdpRespComplementaryItemsGrid_viewer = {|
  +isCompleteTheLookDisabled: ?boolean,
  +$fragmentRefs: PdpRespSimilarItem_viewer$ref,
  +$refType: PdpRespComplementaryItemsGrid_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespComplementaryItemsGrid_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isCompleteTheLookDisabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableCompleteTheLook",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"disableCompleteTheLook\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'acfa22df4f0b5ff5553ebf188bb6b9d9';
module.exports = node;
